import React from 'react';
import { inject, observer} from 'mobx-react';
import {WeaErrorPage,WeaTools,WeaTab,WeaTop,WeaSearchGroup,WeaRightMenus,WeaFormItem,WeaRightMenu} from 'ecCom';
import { Tabs,Button,Table,Form, Modal,message,Row,Col, Spin} from 'antd';
import {WeaSwitch} from 'comsMobx';
import * as mobx from 'mobx';
import isEmpty from 'lodash/isEmpty';
const toJS = mobx.toJS;
import * as PublicFunc from '../util/pulic-func';
window.openFullWindowForXtable = PublicFunc.openFullWindowForXtable;
import moment from 'moment';
import {WeaTableNew} from 'comsMobx';
const WeaTable = WeaTableNew.WeaTable;
import cloneDeep from 'lodash/cloneDeep'
import {i18n} from '../public/i18n';
let _this;

@inject('hrmFinance')
@inject('hrmCard')
@observer
class HrmFinance extends React.Component {
  constructor(props) {
    super(props);
    _this = this;
    const funcs = ['editCard','backCard','saveEditCard', 'onTabChange'];
    funcs.forEach(f=> this[f] = this[f].bind(this))
  }

  componentDidMount() {
    const {hrmCard} = this.props;
    hrmCard.setTopButtons(this.getTopButtons.bind(this));
    hrmCard.setTopRightMenus(this.getRightMenu.bind(this));
    hrmCard.setTopShowDropIcon(true);
    this.init();
  }

  init() {
    const {hrmFinance} = this.props;
    const hrmId = this.props.params.hrmId || '';
    hrmFinance.hrmId = hrmId;
    hrmFinance.init();
    hrmFinance.getTabInfo();
  }


  render(){
    const { hrmFinance } = this.props;
    let {title,form,tabDatas,table,formFields,tabkey,isEditor} = hrmFinance;
    let qname = '';

    const {query} = this.props.location;
    const formParams = form.getFormParams();
    return (
      <div className='wea-myhrm-finance wea-myhrm' style={{background: '#ffffff',height:'100%', position: 'relative'}}>
        <WeaRightMenu datas={this.getRightMenu()}
                    onClick={this.onRightMenuClick}>
          <div style={{minHeight:window.innerHeight-146}}>
            <div style={query.fromcard? {display:'none'} :  {display:''}}>
            <WeaTop
              title={title()}
              icon={<i className='icon-coms-hrm' />}
              iconBgcolor='#217346'
              buttons={this.getTopButtons()}
              buttonSpace={10}
              showDropIcon={true}
              dropMenuDatas={this.getRightMenu()}
            />
            </div>
            <Spin spinning={isEmpty(toJS(table)) && isEmpty(toJS(formFields))} >
            <div className='hrm-my-card-basicInfo hrm-my-cardInfo'>
              {this.getFormField()}
            </div>
            <div style={isEditor||isEmpty(tabDatas)? {display:'none'} : {height: '100%'}}>
            <WeaTab
                selectedKey={tabkey}
                datas={tabDatas}
                keyParam='key'
                onChange={this.onTabChange}
              />
              {this.getTable()}
              </div>
            </Spin>
          </div>
        </WeaRightMenu>
      </div>
    );
  }

  editCard(){
    const {hrmFinance} = this.props;
    hrmFinance.edit();
  }

  saveEditCard(){
    const {hrmFinance} = this.props;
    hrmFinance.save();
  }

  
  backCard(){
    this.init();
  }
  
  getTable(){
    const { hrmFinance } = this.props;
    let {table} = hrmFinance;
    table = toJS(table);
    if(!isEmpty(table)){
      return (<div className="wea-new-table">
        <Table dataSource={table.datas} columns={this.reRenderColumns(table.columns)} pagination={false}/>
      </div>)
    }
  }

  reRenderColumns = (columns) => {
    columns.forEach(c=>{
        if(c.dataIndex.indexOf('column_')!=-1){
            c.render = function(text, record){
                return  <span title={record[c.dataIndex].titles || ''}>{typeof(record[c.dataIndex]) == 'object' ? record[c.dataIndex].value : record[c.dataIndex]}</span>
            }
        }
    })
    return columns;
  }

  getFormField(){
    const {hrmFinance} = this.props;
    let {form, formFields, isEditor} = hrmFinance;
    const {isFormInit} = form;
    let group = [];
    formFields = toJS(formFields);
    isFormInit && formFields.forEach(c =>{
        let items = [];
        c.items.forEach( field => {
          items.push({
            com:(<WeaFormItem
                underline={!isEditor}
                label={`${field.label}`}
                labelCol={{span: `${window.HrmLabelCol}`}}
                wrapperCol={{span: `${window.HrmWrapperCol}`}}>
                  <WeaSwitch fieldConfig={field} form={form}/>
                </WeaFormItem>),
            colSpan: 1
          });
        });
        group.push(<WeaSearchGroup className={`${isEditor?'hrm-center':''} ${c.isHide?'wea-hide':''}`}
          needTigger={true} title={c.title} showGroup={c.defaultshow} items={items} col={window.HrmGroupCol}/>)
    });
    return group;
  }

  onTabChange(key) {
    const {hrmFinance} = this.props;
    hrmFinance.changeTab(key);
  }

  getRightMenu(){
    const {hrmFinance, hrmCard} = this.props;
    const {isEditor, buttons, } = hrmFinance;
    let arr = [];
    if(buttons && buttons.hasEdit){
        if (isEditor){
            arr = [{
                icon: <i className='icon-coms-common'/>,
                content:i18n.button.save(),
                key: 'save',
                onClick: key =>{
                  this.saveEditCard();
                }
            }, {
                icon: <i className='icon-coms-go-back'/>,
                content:i18n.button.back(),
                key: 'back',
                onClick: key =>{
                  this.backCard();
                }
                
            }]
        } else {
            arr = [{
                    icon: <i className='icon-coms-edit'/>,
                    content:i18n.button.modify(),
                    key: 'editCard',
                    onClick: key =>{
                        this.editCard();
                    }
                }
            ]

            arr.push(
            {
              icon: <i className='icon-coms-Print-log'/>,
              content:i18n.button.log(),
              key: 'showLog',
              onClick: key =>{
                window.setLogViewProps({logSmallType:i18n.smallType.HRM_RSOURCE_CARD_FINANCE,targetId:hrmId});
              }
            }
          )
        }
    }
    return arr;
  }
  getTopButtons() {
    const {hrmFinance} = this.props;
    const {isEditor, buttons} = hrmFinance;
    const save = <Button type="primary" onClick={this.saveEditCard} >{i18n.button.save()}</Button>;
    const back = <Button type="primary" onClick={this.backCard} >{i18n.button.back()}</Button>;
    const edit = <Button type="primary" onClick={this.editCard} >{i18n.button.modify()}</Button>;
    const btns = [];
    if (isEditor) {
      if (buttons && buttons.hasSave) {
        btns.push(save);
        btns.push(back);
      }
    } else {
      if (buttons && buttons.hasEdit) {
        btns.push(edit);
      }
    }
    return btns;
  }
}

export default HrmFinance



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/Finance.js